import { render, staticRenderFns } from "./Timeframe.vue?vue&type=template&id=a21b08ca&scoped=true&lang=pug&"
import script from "./Timeframe.vue?vue&type=script&lang=js&"
export * from "./Timeframe.vue?vue&type=script&lang=js&"
import style0 from "./Timeframe.vue?vue&type=style&index=0&id=a21b08ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b08ca",
  null
  
)

export default component.exports